/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */
import * as st from './STApp'
import { componentApi, loadTranslations } from 'common'


export class STGridGeneratorAPI {
  async GetMemoLookupItems(boid : string) : Promise<Array<st.LookupItem>> {
    return await componentApi.call('st', 'st-grid-generator-btn', 'STGridGeneratorAPI', 'GetMemoLookupItems', {
      boid,
    });
  }
  async Generate(hint : string, identity : string, property : string, boid : string, lookupCode : string, style : st.WritingStyle) : Promise<any> {
    return await componentApi.call('st', 'st-grid-generator-btn', 'STGridGeneratorAPI', 'Generate', {
      hint,
      identity,
      property,
      boid,
      lookupCode,
      style,
    });
  }
  async ReviseText(selectedText : string, fullText : string) : Promise<any> {
    return await componentApi.call('st', 'st-grid-generator-btn', 'STGridGeneratorAPI', 'ReviseText', {
      selectedText,
      fullText,
    });
  }
  async GetWritingStyles() : Promise<any> {
    return await componentApi.call('st', 'st-grid-generator-btn', 'STGridGeneratorAPI', 'GetWritingStyles', {
    });
  }
  async SaveWritingStyle(style : st.WritingStyle) : Promise<any> {
    return await componentApi.call('st', 'st-grid-generator-btn', 'STGridGeneratorAPI', 'SaveWritingStyle', {
      style,
    });
  }
}
export default new STGridGeneratorAPI()
